import { Notification } from 'element-ui';

export const errorHandler = (errorInfo, options = { type: 'error' }) => {
  if (!errorInfo) return;
  if (typeof errorInfo === 'string') {
    return Promise.resolve().then(() => {
      setTimeout(() => {
        Notification({
          title: '客户端异常',
          message: errorInfo,
          type: 'warning',
        });
      });
    })  
    
  }

  let { type } = options;
  const { message, title, status } = errorInfo;

  if (status && status === 401) {
    return Promise.resolve().then(() => {
      setTimeout(() => {
        Notification({
          title: '客户端异常',
          message: '您的账号已在其他设备登录，如非本人操作，请重新登录！',
          type: 'warning',
        });
      });
    })  
  }
  if (/^4/g.test(status)) type = 'warning';

  return Promise.resolve().then(() => {
    Notification({
      title,
      message,
      type,
    });
  })
};

export default {};
